import { RegisterOptions } from 'react-hook-form'

export const profileValidation: { [x: string]: RegisterOptions } = {
  email: {
    required: {
      value: true,
      message: 'This field is required'
    },
    pattern: {
      // Matches email addresses
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
      message: 'Invalid email address'
    }
  },
  displayName: {
    required: {
      value: true,
      message: 'This field is required'
    },
    minLength: {
      value: 1,
      message: 'Invalid name'
    }
  }
}
